import { useInfoCenterPrivate, useInfoCenterPublic } from '@content-api/provider';
import { useQuery } from '@tanstack/react-query';

export const useHelpContent = () => {
  const { getFaqs, getSupportTicketSubjects } = useInfoCenterPrivate();
  const { getContactUs } = useInfoCenterPublic();

  const {
    data: faqs,
    isLoading: isFaqsLoading,
    error: faqsError,
  } = useQuery({
    queryKey: ['content-api', 'faqs'],
    queryFn: () => getFaqs(),
  });

  const {
    data: contactUs,
    isLoading: isContactUsLoading,
    error: contactUsError,
  } = useQuery({
    queryKey: ['content-api', 'contact-us'],
    queryFn: () => getContactUs(),
  });

  const {
    data: supportTicketSubjects,
    isLoading: isSupportTicketSubjectsLoading,
    error: supportTicketSubjectsError,
  } = useQuery({
    queryKey: ['content-api', 'support-api-tickets'],
    queryFn: () => getSupportTicketSubjects(),
  });

  return {
    isSupportTicketSubjectsLoading,
    supportTicketSubjectsError,
    supportTicketSubjects,

    isFaqsLoading,
    faqsError,
    faqs,

    isContactUsLoading,
    contactUsError,
    contactUs,
  };
};
